module.exports = __webpack_public_path__ + "img/屈老师.aacd2650.jpeg";